// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__5dnhI","ant-page-header-heading-title":"styles_ant-page-header-heading-title__e3Tqn","table":"styles_table__3elZX"};